import React from 'react';
import styles from './CreateProductContainer.module.scss';

interface CreateProductContainerProps {
  children: React.ReactNode;
}
const CreateProductContainer: React.FC<CreateProductContainerProps> = ({
  children,
}: CreateProductContainerProps) => {
  return <div className={styles.createProductFormContainer}>{children}</div>;
};

export default CreateProductContainer;
